@if (this.action === 'delete') {
  <h1 mat-dialog-title>Delete file</h1>
}
@if (customer_attachments && customer_attachments.length==0 && supplier_attachments && supplier_attachments.length==0) {
  <h1 mat-dialog-title>No attachments for this claim.</h1>
}
<div mat-dialog-content class="attachment-dialog">
  @if (this.action === 'delete') {
    <div>
      Would you like to delete selected attachment?
    </div>
  }

  @if (this.action === 'show') {
    <div>
      <table>
        <tr>
          @if (customer_attachments && customer_attachments.length>0) {
            <td>
              <h1 mat-dialog-title>Customer attachments</h1>
            </td>
          }
          @if (supplier_attachments && supplier_attachments.length>0) {
            <td>
              <h1 mat-dialog-title>Supplier attachments</h1>
            </td>
          }
        </tr>
        <tr>
          @if (customer_attachments && customer_attachments.length>0) {
            <td>
              @for (a of customer_attachments; track a) {
                <a
                  mat-raised-button
                  target="_blank"
                  href="{{a.path}}"
                  class="link-btn"
                  title="{{a.original_filename}}"
                  >
                  <mat-icon class="attachment-icon">{{a.icon}}</mat-icon
                    >{{a.original_filename}}
                  </a>
                }
              </td>
            }
            @if (supplier_attachments && supplier_attachments.length>0) {
              <td>
                @for (a of supplier_attachments; track a) {
                  <a
                    mat-raised-button
                    target="_blank"
                    href="{{a.path}}"
                    class="link-btn"
                    title="{{a.original_filename}}"
                    >
                    <mat-icon class="attachment-icon">{{a.icon}}</mat-icon
                      >{{a.original_filename}}
                    </a>
                  }
                </td>
              }
            </tr>
          </table>
        </div>
      }
    </div>
    <div mat-dialog-actions>
      @if (this.action === 'delete') {
        <div>
          <button mat-button (click)="deleteFile()">Delete file</button>
          <button mat-button (click)="onNoClick()">Cancel</button>
        </div>
      }
      @if (this.action === 'show') {
        <div>
          <button mat-button (click)="onNoClick()">Close</button>
        </div>
      }
    </div>
